import * as React from 'react';
import {
  DataGrid,
  GridActionsCellItem
} from '@mui/x-data-grid';

import api from "../../services/api";
import {
  Paper,
  Button,
  Typography,
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import DeleteIcon from '@mui/icons-material/Delete';
import { useStoreActions } from 'easy-peasy';
import {
  NoRowsOverlay
} from '../../components';
import DialogoAutorizaTemasUsuarios from './DialogoAutorizaTemasUsuarios';
import DialogoConfirmaExclusaoPreenchedorSSO
from './DialogoConfirmaExclusaoPreenchedorSSO.js';

const Usuarios = () => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [rows, setRows] = React.useState([]);
  const [openDlgUsuario, setOpenDlgUsuario] = React.useState(false);
  const [roles,setRoles] = React.useState([]);
  const [columns,setColumns] = React.useState([]);
  const [usuario,setUsuario] = React.useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [idDelete, setIdDelete]= React.useState(null);

  const loadRoles = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/roles')).data;
      if(mount.isMounted) {
        setRoles(data);
        setColumns(getColumns(data.reduce((map, role)=>{
          map[role.id] = role.name;
          return map;
        },{})));
      }
      stopLoading();
    } catch(error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  React.useEffect(()=>{
    let mount = {
      isMounted: true
    };
    loadRoles(mount);
    return () => {
      mount.isMounted = false;
    };
  },[]);


const deleteUser = React.useCallback((id, roleId) => async () => {
  if (roleId === 'preenchedorSso') {
    setIdDelete(id);
    openConfirmDialog();
  } else {
    await deleteUserConfirmed(id);
  }
}, []);

const deleteUserConfirmed = async (id) => {
  startLoading();
  try {
    await api.http.delete('/users/' + id + '?gestao=true');
    stopLoading({ severity: 'success' });
    closeConfirmDialog();
    reloadUsers();
  } catch (error) {
    stopLoading({
      message: error.toString(),
      severity: 'error'
    });
  }
};

// Função para abrir o diálogo de confirmação
const openConfirmDialog = () => {
  setConfirmDialogOpen(true);
};

// Função para fechar o diálogo de confirmação
const closeConfirmDialog = () => {
  setConfirmDialogOpen(false);
};

  const getColumns = (rolesObj) => {
    return [{
      field: 'email',
      headerName: 'E-mail',
      flex: 5,
    },{
      field: "temas",
      flex:1,
      headerName: 'Tema',
      type: 'string',
      editable: false,
    },{
      field: 'roleId',
      headerName: 'Perfil',
      flex: 1,
      valueGetter: (value) => rolesObj[value]
    },{
      field: 'actions',
      type: 'actions',
      headerName: 'Remover',
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={deleteUser(params.id,params.row.roleId)}
        />
      ],
    }];
  };

  const adiciona = async () => {
    setOpenDlgUsuario(true);
  };

  const onCloseDlgUsuario = (reload=false) => {
    setUsuario(null);
    setOpenDlgUsuario(false);
    if(reload) {
      reloadUsers();
    }
  };

  const onRowClick = (params, event, details) => {
    if(params.row.roleId!='admin') {
      setUsuario(params.row);
      setOpenDlgUsuario(true);
    }
  };

  const reloadUsers = async (mount) => {
    startLoading();
    try {
      let users = (await api.http.get('/users?gestao=1')).data;
      if(!mount || mount.isMounted)
        setRows(users);

      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };


  React.useEffect(()=> {
    let mount = {
      isMounted: true,
    };
    reloadUsers(mount);
    return () => {
      mount.isMounted = false;
    };
  },[]);


  return (
    (<React.Fragment>
      <DialogoAutorizaTemasUsuarios
        open={openDlgUsuario}
        onClose={onCloseDlgUsuario}
        roles={roles}
        usuario={usuario}
      />
      <Grid container spacing={3} sx={{ 'my': 2 }}>
        <Grid style={{ 'textAlign': 'left' }} size="grow">
          <Typography variant="h4">Usuários</Typography>
        </Grid>
        <Grid style={{ 'textAlign': 'right' }} size="grow">
          <Button color="primary" variant="outlined" onClick={adiciona}>
            Autorizar novo usuário
          </Button>
        </Grid>
      </Grid>
      <Paper variant="elevation" elevation={2} style={{ height: 400, width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          onRowClick={onRowClick}
          disableSelectionOnClick
          slots={{ noRowsOverlay: NoRowsOverlay }}   />
      </Paper>
      <DialogoConfirmaExclusaoPreenchedorSSO
        open={confirmDialogOpen}
        onClose={closeConfirmDialog}
        onDelete={()=>deleteUserConfirmed(idDelete)}
      />
    </React.Fragment>)
  );
};

export default Usuarios;
